import React, {
  Dispatch,
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";
import { ItemTypes, PopupsListType, SimulationType } from "./RightSideMenu";
import DataTable, {
  GenerateEarlyWarningTypes,
} from "../../mainLayer/simulationPopup/DataTable";
import loadIco from "../../assets/loading-ico.gif";
import closeIco from "../../assets/close-icon-color.png";
import { NotificationType } from "../../mainLayer/simulationPopup/NotificationPopup";
import { map } from "../../mainLayer/MainLayer";
import Overlay from "ol/Overlay";
import ReactDOM from "react-dom";
import SimulationPopup from "../../mainLayer/simulationPopup/SimulationPopup";
import "../../App.css";
import ViewMap from "../../simulation/SimulationPopUp/SimulationPopUpMap/ViewSimulationMap";
import ViewForecastMap from "../../simulation/Forecast/ForecastMap/ViewForecastMap";

const rows: GenerateEarlyWarningTypes[] = [
  {
    id: 51040,
    buildingId: 51040,
    buildingType: "BLDGA",
    buildingOwnerName: "Nihal Perera",
    mobileNumber: "0711111111",
    areaOfRisk: "91780.2011292",
    maximumDepth: 200,
    startTime: "05/01/2024, 18:00",
    peakTime: "05/01/2024, 18:00",
  },
  {
    id: 51041,
    buildingId: 51041,
    buildingType: "BLDGA",
    buildingOwnerName: "Gihan Fernando",
    mobileNumber: "0711111111",
    areaOfRisk: "91780.2011292",
    maximumDepth: 200,
    startTime: "05/01/2024, 18:00",
    peakTime: "05/01/2024, 18:00",
  },
];

type SideMenuPopupsType = {
  setWindowState: Dispatch<React.SetStateAction<boolean>>;
  terminalState: Dispatch<React.SetStateAction<boolean>>;
  terminalCommands: Dispatch<React.SetStateAction<string[]>>;
  notifications: Dispatch<React.SetStateAction<NotificationType[]>>;
  removeItem: (id: string, type: ItemTypes) => void;
  handleClosePopup: () => void;
  runButtonOnClick: (simulationName: string) => void;
  addItem: (id: string, type: ItemTypes) => void;
  data: SimulationType;
  setIsSideMenuSimulationStatus: Dispatch<React.SetStateAction<boolean>>;
};

const SideMenuFloodSimulation = (props: SideMenuPopupsType) => {
  // Selected tab
  const [selectedTab, setSelectedTab] = useState<
    | "simulation_tab"
    | "forecast_tab"
    | "analyse_impact_tab"
    | "generate_early_warning_tab"
  >("simulation_tab");
  // custom value status
  const [isCustomValueOpen, setIsCustomValueOpen] = useState<boolean>(false);
  // Loading screen
  const [isLoading, setIsLoading] = useState<boolean>(false);

  // Data
  // Flood model type data
  const [floodModelTypes, setFloodModelTypes] = useState<
    { name: string; value: string }[]
  >([
    { name: "GloFas", value: "GloFas" },
    { name: "Anuga", value: "Anuga" },
    { name: "Hecras", value: "Hecras" },
    { name: "CMOD", value: "CMOD" },
  ]);
  // Forecast type data
  const [forecastTypes, setForecastTypes] = useState<
    { name: string; value: string }[]
  >([
    { name: "ESWF", value: "ESWF" },
    { name: "GWF", value: "GWF" },
  ]);
  // River sensors data
  const [riverSensorTypes, setRiverSensorTypes] = useState<
    { name: string; value: string }[]
  >([
    { name: "Irrigation Department", value: "Irrigation Department" },
    { name: "NBRO Department", value: "NBRO Department" },
    { name: "Community", value: "Community" },
  ]);
  // River sensors data
  const [buildingDataFrom, setBuildingDataFrom] = useState<
    { name: string; value: string }[]
  >([
    { name: "Irrigation Department", value: "Irrigation Department" },
    { name: "NBRO Department", value: "NBRO Department" },
    { name: "Met Office", value: "Met Office" },
    { name: "Community", value: "Community" },
  ]);

  // Input values
  const simulationNameRef = useRef<HTMLInputElement | null>(null);
  const simulationFloodModelRef = useRef<HTMLSelectElement | null>(null);
  const simulationForecastRef = useRef<HTMLSelectElement | null>(null);
  const simulationRiverSensorsRef = useRef<HTMLSelectElement | null>(null);
  const forecastShowCatchmentAreaRef = useRef<HTMLInputElement | null>(null);
  const forecastPublishRef = useRef<HTMLInputElement | null>(null);

  // Handle close
  const handleClosePopupClick = () => {
    props.setIsSideMenuSimulationStatus(false);
  };

  // Handle forecast tab next button click
  const handleForecastTabNextButtonClick = () => {
    console.log("forecast tab next button clicked");
    setSelectedTab("analyse_impact_tab");
  };

  // Handle analyse impact tab next button click
  const handleAnalyseImpactTabNextButtonClick = () => {
    console.log("analyse impact tab next button clicked");
    setSelectedTab("generate_early_warning_tab");
  };

  // Handle generate ew tab next button click
  const handleGenerateEWTabNextButtonClick = () => {
    console.log("generate ew tab trigger button clicked");
  };

  // Handle simulation tab next button click
  const handleSimulationTabNextButtonClick = () => {
    setIsLoading(true);
    /* if(simulationNameRef.current?.value && simulationFloodModelRef.current?.value !== 'null' && simulationForecastRef.current?.value !== 'null')
        {
          console.log('run')
        } */
    setIsLoading(true);
    props.terminalState(true);
    props.terminalCommands((prevState) => [
      ...prevState,
      "terminal starting....",
    ]);
    let count = 0;
    const terminalData = setInterval(() => {
      props.terminalCommands((prevState) => [...prevState, "command " + count]);
      count += 1;

      if (count > 10) {
        clearTimeout(terminalData);
        props.terminalCommands((prevState) => [
          ...prevState,
          "terminal ended....",
        ]);
        setIsLoading(false);
        props.notifications((prevState) => [
          ...prevState,
          { type: "success", message: "test successfully completed" },
        ]);
      }
    }, 500);
  };

  const [isNotRelease, setIsNotRelease] = useState<boolean>(true);

  const popupRef = useRef<HTMLDivElement | null>(null);
  const popupElement = document.createElement("earlyWarningElement");

  const mouseMoveEvent = useCallback(
    (event: MouseEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        if (sideMenuWidth > event.clientX) {
          ReactDOM.render(
            <SimulationPopup
              terminalState={props.terminalState}
              terminalCommands={props.terminalCommands}
              notifications={props.notifications}
              handleClosePopup={props.handleClosePopup}
              runButtonOnClick={props.runButtonOnClick}
              id={props.data.id}
              addItem={props.addItem}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });

          overlay.setPosition([80.771797, 7.873054]);
          map.addOverlay(overlay);
          props.removeItem(props.data.id, "simulation");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

  const mouseMoveEventTouch = useCallback(
    (event: TouchEvent) => {
      const sideMenu = document.getElementById("side-menu-wrapper");

      if (sideMenu && isNotRelease) {
        const sideMenuWidth = Number(
          window.getComputedStyle(sideMenu).left.slice(0, -2)
        );

        const touchX = event.touches[0].clientX; // Get touch position

        if (sideMenuWidth > touchX) {
          ReactDOM.render(
            <SimulationPopup
              terminalState={props.terminalState}
              terminalCommands={props.terminalCommands}
              notifications={props.notifications}
              handleClosePopup={props.handleClosePopup}
              runButtonOnClick={props.runButtonOnClick}
              id={props.data.id}
              addItem={props.addItem}
            />,
            popupElement
          );

          const overlay = new Overlay({
            element: popupElement,
            autoPan: {
              animation: {
                duration: 250,
              },
            },
          });

          overlay.setPosition([80.771797, 7.873054]);
          map.addOverlay(overlay);
          props.removeItem(props.data.id, "simulation");
          setIsNotRelease(false);
        }
      }
    },
    [isNotRelease]
  );

  useEffect(() => {
    const handleMouseDown = () => {
      document.addEventListener("mousemove", mouseMoveEvent);
      document.addEventListener("mouseup", handleMouseUp);
    };

    const handleMouseUp = () => {
      document.removeEventListener("mousemove", mouseMoveEvent);
      document.removeEventListener("mouseup", handleMouseUp);
    };

    const handleTouchStart = () => {
      document.addEventListener("touchmove", mouseMoveEventTouch);
      document.addEventListener("touchend", handleTouchEnd);
    };

    const handleTouchEnd = () => {
      document.removeEventListener("touchmove", mouseMoveEventTouch);
      document.removeEventListener("touchend", handleTouchEnd);
    };

    if (popupRef.current) {
      popupRef.current.addEventListener("mouseenter", () => {
        popupRef.current?.addEventListener("mousedown", handleMouseDown);
        popupRef.current?.addEventListener("touchstart", handleTouchStart);
      });
    }

    return () => {
      document.removeEventListener("mousemove", mouseMoveEvent);
      document.removeEventListener("mouseup", handleMouseUp);
      document.removeEventListener("touchmove", mouseMoveEventTouch);
      document.removeEventListener("touchend", handleTouchEnd);
    };
  }, [mouseMoveEvent, mouseMoveEventTouch]);

  return (
    <div className={`popup`} ref={popupRef}>
      <div className={`titleWrapper`}>
        <span>Simulation</span>
        <div className={`titleButtonContainer no-drag`}>
          {/* <i className={`titleIcon fullScreenIco`}></i> */}
          <i
            className={`titleIcon closeIco`}
            onClick={(e) => handleClosePopupClick()}
            onTouchStart={(e) => handleClosePopupClick()}
          ></i>
        </div>
      </div>
      {/* Tab area */}
      <div className={`tabArea no-drag`}>
        <div
          className={`tabButton ${
            selectedTab === "simulation_tab" ? "tabSelected" : ""
          }`}
          id="simulation_tab"
          onClick={(e) => setSelectedTab((prevState) => "simulation_tab")}
          onTouchStart={(e) => setSelectedTab((prevState) => "simulation_tab")}
        >
          simulation
        </div>
        <div
          className={`tabButton ${
            selectedTab === "forecast_tab" ? "tabSelected" : ""
          }`}
          id="forecast_tab"
          onClick={(e) => setSelectedTab((prevState) => "forecast_tab")}
          onTouchStart={(e) => setSelectedTab((prevState) => "forecast_tab")}
        >
          forecast
        </div>
        <div
          className={`tabButton ${
            selectedTab === "analyse_impact_tab" ? "tabSelected" : ""
          }`}
          id="analyse_impact_tab"
          onClick={(e) => setSelectedTab((prevState) => "analyse_impact_tab")}
          onTouchStart={(e) =>
            setSelectedTab((prevState) => "analyse_impact_tab")
          }
        >
          analyse impact
        </div>
        <div
          className={`tabButton ${
            selectedTab === "generate_early_warning_tab" ? "tabSelected" : ""
          }`}
          id="generate_early_warning_tab"
          onClick={(e) =>
            setSelectedTab((prevState) => "generate_early_warning_tab")
          }
          onTouchStart={(e) =>
            setSelectedTab((prevState) => "generate_early_warning_tab")
          }
        >
          generate early warning
        </div>
      </div>
      <div className={`simulation-wrapper`}>
        {/* Simulation data container */}
        {selectedTab === "simulation_tab" && (
          <div className={`simulationTabDataWrapper tabDataContainer`}>
            {/* Left data container */}
            <div className={`leftDataContainer`}>
              <div className={`inputItemContainer no-drag`}>
                <label htmlFor="simulation_popup_simulation_name_input">
                  simulation name
                </label>
                <input
                  id="simulation_popup_simulation_name_input"
                  type="text"
                  placeholder="Enter Simulation name"
                  ref={simulationNameRef}
                />
              </div>

              <div className={`inputItemContainer no-drag`}>
                <label htmlFor="simulation_popup_flood_model_select">
                  flood model type
                </label>
                <select
                  name="flood_model_type"
                  id="simulation_popup_flood_model_select"
                  ref={simulationFloodModelRef}
                >
                  <option value={""} disabled selected>
                    Select...
                  </option>
                  {floodModelTypes.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className={`inputItemContainer no-drag`}>
                <label htmlFor="simulation_popup_forecast_select">
                  forecast
                </label>
                <select
                  name="forecast_type"
                  id="simulation_popup_forecast_select"
                  ref={simulationForecastRef}
                >
                  <option value={""} disabled selected>
                    Select...
                  </option>
                  {forecastTypes.map((option, index) => (
                    <option key={index} value={option.value}>
                      {option.name}
                    </option>
                  ))}
                </select>
              </div>

              <div className={`customValueWrapper no-drag`}>
                <div
                  className={`titleWrapper`}
                  onClick={(e) =>
                    setIsCustomValueOpen((prevStatus) => !prevStatus)
                  }
                  onTouchStart={(e) =>
                    setIsCustomValueOpen((prevStatus) => !prevStatus)
                  }
                >
                  <span className={`title`}>custom value</span>
                  <div
                    className={`icon ${isCustomValueOpen ? "bgUp" : "bgDown"}`}
                  ></div>
                </div>
                <div
                  className={`dataContainer`}
                  style={{ display: isCustomValueOpen ? "block" : "none" }}
                >
                  <div className={`inputItemContainer`}>
                    <label htmlFor="simulation_popup_river_sensors_select">
                      river sensors
                    </label>
                    <select
                      name="river_sensor_type"
                      id="simulation_popup_river_sensors_select"
                      ref={simulationRiverSensorsRef}
                    >
                      <option value={""} disabled selected>
                        Select...
                      </option>
                      {riverSensorTypes.map((option, index) => (
                        <option key={index} value={option.value}>
                          {option.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>
            </div>
            {/* Right map container */}
            <div className={`rightMapContainer no-drag`}>
              {/* Map here */}
              <ViewMap />
            </div>
            <div className={`bottomContainer no-drag`}>
              <button
                onClick={(e) => handleSimulationTabNextButtonClick()}
                onTouchStart={(e) => handleSimulationTabNextButtonClick()}
              >
                run
              </button>
            </div>
          </div>
        )}

        {/* Forecast data container */}
        {selectedTab === "forecast_tab" && (
          <div className={`forecastTabDataWrapper tabDataContainer`}>
            <div className={`forecastMap no-drag`}>
              {/* Forecast map here */}
              {/* <div
        style={{
            display:"inline-block",
            height: "50vh",
            width: "30vw",
          }}
        >
          <ViewForecastMap />
        </div> */}

              <ViewForecastMap />
            </div>
            <div className={`bottomMenu no-drag`}>
              <input
                type="checkbox"
                name=""
                id="simulation_popup_forecast_show_catchment_area"
                ref={forecastShowCatchmentAreaRef}
              />
              <label htmlFor="simulation_popup_forecast_show_catchment_area">
                show catchment area
              </label>

              <input
                type="checkbox"
                name=""
                id="simulation_popup_publish"
                ref={forecastPublishRef}
              />
              <label htmlFor="simulation_popup_publish">publish</label>

              <button
                onClick={(e) => handleForecastTabNextButtonClick()}
                onTouchStart={(e) => handleForecastTabNextButtonClick()}
              >
                next
              </button>
            </div>
          </div>
        )}

        {/* Analyse impact data container */}
        {selectedTab === "analyse_impact_tab" && (
          <div className={`analyseImpactTabDataWrapper tabDataContainer `}>
            <span className={`titleContainer`}>
              Select to generate early warning
            </span>
            <div className={`buildingDataFromSelector no-drag`}>
              <label htmlFor="">Building Data From</label>
              <select name="" id="">
                <option value={""} disabled selected>
                  Select...
                </option>
                {buildingDataFrom.map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
            <div className={`checkBoxContainer no-drag`}>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_buildingID"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_buildingID">Building ID</label>
              </div>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_building_owner_name"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_building_owner_name">
                  Building Owner Name
                </label>
              </div>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_mobile_number"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_mobile_number">
                  Mobile Number
                </label>
              </div>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_building_type"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_building_type">
                  Building Type
                </label>
              </div>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_maximum_depth"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_maximum_depth">
                  Maximum Depth
                </label>
              </div>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_start_time"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_start_time">Start Time</label>
              </div>
              <div className={`item`}>
                <input
                  type="checkbox"
                  name=""
                  id="simulation_popup_peak_type"
                  ref={forecastPublishRef}
                />
                <label htmlFor="simulation_popup_peak_type">Peak Type</label>
              </div>
            </div>
            <div className={`bottomContainer no-drag`}>
              <button
                onClick={(e) => handleAnalyseImpactTabNextButtonClick()}
                onTouchStart={(e) => handleAnalyseImpactTabNextButtonClick()}
              >
                next
              </button>
            </div>
          </div>
        )}

        {/* Generate early warning data container */}
        {selectedTab === "generate_early_warning_tab" && (
          <div
            className={`generateEarlyWarningTabDataWrapper tabDataContainer`}
          >
            <div className={`tableContainer no-drag`}>
              {/* Table here */}
              <DataTable data={rows} />
            </div>

            <div className={`bottomContainer no-drag`}>
              <button
                onClick={(e) => handleGenerateEWTabNextButtonClick()}
                onTouchStart={(e) => handleGenerateEWTabNextButtonClick()}
              >
                trigger
              </button>
            </div>
          </div>
        )}

        {/* Loading screen */}
        {isLoading && (
          <div className={`loadingScreen no-drag`}>
            <img className={`loadImg`} src={loadIco} alt="" />
            <img
              className={`closeImg`}
              src={closeIco}
              alt=""
              onClick={(e) => {
                setIsLoading(false);
                /* props.terminalState(false)
                            props.terminalCommands([]) */
              }}
              onTouchStart={(e) => {
                setIsLoading(false);
                /* props.terminalState(false)
                            props.terminalCommands([]) */
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default SideMenuFloodSimulation;
